export default __webpack_public_path__ + "static/media/A63.36f0215e.jpeg";